import React from 'react';
import { WindowManager } from '@shared/ui-react/FloatingWindow';
import { layerStore } from '@shared/openlayers/tools/volume/utils/store/layer-store';
import { MapToolsStore } from '@openlayers/MapToolsStore';
import { VolumeCalculationConfig } from './components/volumes-dialog';

export function openVolumeWindow(toolsStore: MapToolsStore) {
    WindowManager.open({
        group: 'map-tools',
        id: 'volume-tool',
        title: __('js_map_measuring_tools.volume_tool'),
        showCloseButton: true,
        preventCloseOthers: true,
        allowMultiple: false,
        className: 'volume-tool-window',
        resize: 'both',
        defaultSizing: {
            width: window.innerWidth * 0.25,
            height: 250 + window.innerHeight * 0.6,
            x: window.innerWidth - window.innerWidth * 0.25 - 20,
            y: window.innerHeight - window.innerHeight * 0.9,
        },
        helpButtonLink: 'https://support.infrakit.com/help/volume-measure-models-saved',
        body: <VolumeCalculationConfig toolsStore={toolsStore} />,
        onClose: () => closeVolumeWindow(toolsStore),
    });
};

export function closeVolumeWindow(toolsStore: MapToolsStore) {
    toolsStore.volumeTool.clearAll();
    layerStore.setReference(null);
    layerStore.setTarget(null);
    WindowManager.close('volume-tool');
}

export function closeWindow() {
    WindowManager.close('volume-tool');
}
